import { isDesktopRuntime } from "./desktop";

export const desktopHostedCheckoutCopy =
  "Checkout URL copied. Open it in your browser. Billing returns to the web app, not this desktop window.";

export function hostedHttpsUrl(value: string): string {
  const url = new URL(value);
  if (url.protocol !== "https:") {
    throw new Error("invalid_operation");
  }
  return url.toString();
}

export async function followHostedHttpsUrl(
  value: string,
  mode: "navigate" | "tab" = "navigate",
): Promise<"copied" | "navigated" | "opened"> {
  const url = hostedHttpsUrl(value);
  if (isDesktopRuntime()) {
    await navigator.clipboard.writeText(url);
    return "copied";
  }
  if (mode === "tab") {
    window.open(url, "_blank", "noopener,noreferrer");
    return "opened";
  }
  window.location.assign(url);
  return "navigated";
}
